import React, { useState, useEffect } from 'react';
import './Popup.css'; // Import the CSS for Popup component
import Getintouch from '../GetInTouch/GetInTouch'
const Popup = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show the popup after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10000); // 10000ms = 10 seconds

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="custom-popup-overlay">
      <div className="custom-popup-content">
        <button className="custom-close-btn" onClick={closePopup}>×</button>
 <Getintouch/>
      </div>
    </div>
  );
};

export default Popup;
